<template>
  <div class="courses">
    <div>
      <h1 class="title text-3xl font-bold text-gray-900 mb-4">My Courses</h1>

      <div class="course-card" :style="{ backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color') + '20' }">
        <div v-if="!isCourseLoading">
          <div v-if="assignedCourse">
            <div class="course-image-placeholder">
              <img class="course-image-placeholder" :src="assignedCourse.image_url" alt="" />
            </div>
            <p class="enrollment-text">You are currently enrolled in the {{ assignedCourse.title }} course.</p>
          </div>
          <div v-else class="enrollment-text">
            <p>You are currently not enrolled in any course.</p>
          </div>
          <div class="button-group">
            <button
              class="launch-button"
              :style="{ backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color'), color: 'white' }"
            >
              LAUNCH COURSE
            </button>
            <button
              class="track-button"
              :style="{
                borderColor: get(getLoggedInUser, 'linked_entity.primary_color'),
                backgroundColor: 'white',
                color: get(getLoggedInUser, 'linked_entity.primary_color'),
              }"
            >
              TRACK PROGRESS
            </button>
          </div>
        </div>
        <div v-else>
          <i class="fas fa-circle-notch fa-spin text-muted" style="font-size:30px;"></i>
        </div>
      </div>

      <div class="history-section">
        <a
          href="#"
          class="history-link"
          :style="{
            color: get(getLoggedInUser, 'linked_entity.primary_color'),
          }"
          >View history from other courses</a
        >
        <p class="history-description">
          Access your completed courses and certificates from previous enrollments.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { get } from 'lodash';
// import Page from '@/components/Page.vue';

export default {
  name: 'CourseHome',
  // extends: Page,
  data() {
    return {
      assignedCourse: null,
      isCourseLoading: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },
  methods: {
    ...mapActions('courses', ['getStdAssignedCourse']),
    get,
    async fetchStudentAssignedCourse() {
      this.isCourseLoading = true;
      const resp = await this.getStdAssignedCourse();
      this.assignedCourse = resp.data.title ? resp.data : null;
      this.isCourseLoading = false;
    },
  },
  mounted() {
    this.fetchStudentAssignedCourse();
  },
};
</script>

<style scoped>
.courses {
  min-height: 100vh;
  padding: 2rem 1rem;
}

.title {
  text-align: center;
  font-size: 2rem;
  font-weight: 800;
}

.course-card {
  border-radius: 12px;
  padding: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  width: 80%;
  justify-self: center;
}

.course-image-placeholder {
  width: 200px;
  height: 150px;
  background-color: #d4b896;
  border-radius: 8px;
  margin: 0 auto 2rem auto;
}

.enrollment-text {
  font-size: 1.125rem;
  color: #2d3748;
  margin-bottom: 2rem;
  font-weight: 700;
}

.button-group {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.launch-button {
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.025em;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.track-button {
  background-color: white;
  color: #3182ce;
  border: 1px solid #3182ce;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.025em;
  cursor: pointer;
  transition: all 0.2s ease;
}

.track-button:hover {
  background-color: #f7fafc;
}

.history-section {
  text-align: center;
  margin-top: 2rem;
}

.history-link {
  color: #3182ce;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  display: block;
  margin-bottom: 0.5rem;
}

.history-link:hover {
  text-decoration: underline;
}

.history-description {
  color: #718096;
  font-size: 0.875rem;
  margin: 0;
}

@media (max-width: 640px) {
  .container {
    padding: 0 0.5rem;
  }

  .course-card {
    padding: 1.5rem;
  }

  .button-group {
    flex-direction: column;
    gap: 0.75rem;
  }

  .launch-button,
  .track-button {
    width: 100%;
    max-width: 280px;
  }

  .title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
}
</style>
